import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { selectors } from "@Src/redux/reducers";
import { defaultLocale } from "./i18nUtil";
import { translate } from "./translate";

// Global cache to store translations across all component instances
const translationCache = new Map();

const TranslateAsync = ({ text, displayHTML = false }) => {
  const language = useSelector(selectors.getLanguageSelector);
  const [translatedText, setTranslatedText] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    if (!text) return;

    mountedRef.current = true;

    if (language === defaultLocale) {
      setTranslatedText(null);
      return;
    }

    const cacheKey = `${text}_${language}`;

    if (translationCache.has(cacheKey)) {
      if (mountedRef.current) {
        setTranslatedText(translationCache.get(cacheKey));
      }
      return;
    }

    translate(text, language, (res) => {
      translationCache.set(cacheKey, res);
      if (mountedRef.current) {
        setTranslatedText(res);
      }
    });

    return () => {
      mountedRef.current = false;
    };
  }, [text, language]);

  if (!text) return null;

  // English/default -> return original text directly
  if (language === defaultLocale) {
    if (displayHTML) {
      return <span dangerouslySetInnerHTML={{ __html: String(text) }} />;
    }
    return text;
  }

  // Non-default -> wait for translation
  if (!translatedText) return null;

  if (displayHTML) {
    return <span dangerouslySetInnerHTML={{ __html: translatedText }} />;
  }
  return translatedText;
};

TranslateAsync.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  displayHTML: PropTypes.bool,
};

export default TranslateAsync;
